import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { ConfigService } from 'src/app/shared/services/config.service';
import { ConfigDto } from 'src/app/shared/interfaces/config';

@Component({
  selector: 'app-profil',
  templateUrl: './profil.component.html',
  styleUrls: ['./profil.component.scss'],
})
export class ProfilComponent implements OnInit {
  public currentIDparams = 0;
  public boxes_params = [
    {
      id: 2,
      title: 'Paramètres personnels',
      click: () => {
        this.router.navigateByUrl('/private/ic/profil/personal-params');
        this.currentIDparams = 2;
      },
    },
    {
      id: 3,
      title: 'Griffe',
      click: () => {
        this.router.navigateByUrl('/private/ic/profil/signature');
        this.currentIDparams = 3;
      },
    },
  ];

  constructor(
    public toastr: ToastrService,
    public router: Router,
    private configService: ConfigService
  ) {}

  ngOnInit(): void {
    this.configService.fetchConfig().subscribe({
      next: (res: ConfigDto) => {
        if (res.isSmtpConfigured) {
          this.boxes_params.push({
            id: 1,
            title: 'Notifications',
            click: () => {
              this.router.navigateByUrl('/private/ic/profil/notifications');
              this.currentIDparams = 1;
            },
          });
        }
      },
    });
  }
}
